var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barra-cont"},[_c('div',{staticClass:"barra-porcentaje",class:{ 'barra-disabled': _vm.isDisabled },style:({
      '--valor-actual': _vm.isDisabled ? 100 : _vm.actual
    })}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isDisabled && _vm.deseada > 0),expression:"!isDisabled && deseada > 0"}],staticClass:"barra-wrapper",style:({
      '--valor-deseado': _vm.deseada
    })}),_vm._v(" "),(!_vm.isDisabled)?_c('span',{staticClass:"etiqueta"},[_vm._v("\n    "+_vm._s(_vm.actual)+"%\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-543e31b7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cultura/sections/results/BarraRenderer.vue
// module id = 1905
// module chunks = 2